module.exports = __webpack_public_path__ + "media/custom/images/pocstock_contribute-step-03-b4b34a1ba6aa339d3bce1e15ce00bfdf.png";